import { Failure } from "@pdfking/errors"
import type { Validator } from "@pdfking/forms"
import type { ComponentFailure } from "@pdfking/imposition/internal"
import type { ImpositionSchema } from "@pdfking/imposition/internal"
import { ApplyComponentFailures } from "@pdfking/imposition/internal"

/**
 * Mirrors Python `clean_print_mode` (`packing/presets/base.py:236-248`): a
 * printing job on a book component must print both sides. Fails the offending
 * job's `print_mode`.
 */
export const ValidateBookInteriorDuplex: Validator<ImpositionSchema> = results => {
  if (results.component_array.error) return results

  const failures: ComponentFailure[] = []

  const components = results.component_array.value ?? []
  components.forEach((component, ci) => {
    if (!component.grow_kind.is_book) return
    component.job_array.forEach(({ print_mode: { is_front, is_rear, id } }, index) => {
      if ((is_front || is_rear) && !(is_front && is_rear)) {
        failures.push({
          path: [ci, "job_array", index, "print_mode"],
          error: Failure("BOOK_INTERIOR_MUST_BE_DUPLEX", {
            input: id,
          }),
        })
      }
    })
  })

  return ApplyComponentFailures(results, failures)
}
